import { resolveBaseUrl } from './apiBootstrap';
import { getAuthToken, unauthorised } from './authToken';

export type FeedbackKind = 'note' | 'flag';
export type FeedbackStatus = 'open' | 'resolved';

export type FeedbackItem = {
  id: string;
  registry: string;
  item_id: string;
  item_label: string;
  reviewer: string;
  kind: FeedbackKind;
  message: string;
  status: FeedbackStatus;
  timestamp: string;
};

export type FeedbackCounts = { open: number; total: number };
export type FeedbackSummary = Record<string, FeedbackCounts>;

async function req<T>(path: string, init: RequestInit): Promise<T> {
  const res = await fetch(`${resolveBaseUrl()}${path}`, init);
  if (res.status === 401) throw unauthorised(path, init);
  if (!res.ok) {
    let detail = res.statusText;
    try { const d = await res.json(); if (d?.detail) detail = d.detail; } catch { /* ignore */ }
    throw new Error(detail);
  }
  return (await res.json().catch(() => ({}))) as T;
}

function authedGet(): RequestInit {
  const t = getAuthToken();
  return { headers: t ? { Authorization: `Bearer ${t}` } : {} };
}
function authedPost(body?: unknown): RequestInit {
  const t = getAuthToken();
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(t ? { Authorization: `Bearer ${t}` } : {}) },
    body: body === undefined ? undefined : JSON.stringify(body),
  };
}

export const feedbackApi = {
  list: (registry?: string, itemId?: string): Promise<FeedbackItem[]> => {
    const qs = new URLSearchParams();
    if (registry) qs.set('registry', registry);
    if (itemId) qs.set('item_id', itemId);
    const q = qs.toString();
    return req<{ items: FeedbackItem[] }>(`/advisor/feedback${q ? `?${q}` : ''}`, authedGet()).then((r) => r.items);
  },
  summary: (registry: string): Promise<FeedbackSummary> =>
    req<{ summary: FeedbackSummary }>(`/advisor/feedback-summary?registry=${encodeURIComponent(registry)}`, authedGet()).then((r) => r.summary),
  create: (body: { registry: string; item_id: string; item_label?: string; kind: FeedbackKind; message: string }): Promise<FeedbackItem> =>
    req<{ item: FeedbackItem }>('/advisor/feedback', authedPost(body)).then((r) => r.item),
  resolve: (feedbackId: string): Promise<FeedbackItem> =>
    req<{ item: FeedbackItem }>(`/advisor/feedback/${encodeURIComponent(feedbackId)}/resolve`, authedPost()).then((r) => r.item),
};
